import * as Yup from 'yup'

export const ChangePasswordSchema = Yup.object().shape({
    currentPassword: Yup.string().required('Current password is required').min(3, 'Password must be at 3 char long'),
    newPassword: Yup.string().required('New password is required').min(3, 'Password must be at 3 char long'),
    confirmPassword: Yup.string().required('Confirm password is required').min(3, 'Password must be at 3 char long'),
})
